import { apiUrl } from "./api";
import { ProficienciesProgressGroupsResponse, ProficienciesProgressResponse } from "../types/proficiencies";

export async function fetchProficienciesProgress({
  pilotUid,
  group,
}: {
  pilotUid: string;
  group: string;
}): Promise<ProficienciesProgressResponse> {
  const url = apiUrl("/proficiencies/progress");
  const params = new URLSearchParams();

  params.set("pilot_uid", pilotUid);
  params.set("group", group);
  url.search = params.toString();

  const response = await fetch(url.toString());
  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return (await response.json()) as ProficienciesProgressResponse;
}

export async function fetchProficienciesProgressGroups({
  pilotUid,
}: {
  pilotUid: string;
}): Promise<ProficienciesProgressGroupsResponse> {
  const url = apiUrl("/proficiencies/progress_groups");
  const params = new URLSearchParams();

  params.set("pilot_uid", pilotUid);
  url.search = params.toString();

  const response = await fetch(url.toString());
  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return (await response.json()) as ProficienciesProgressGroupsResponse;
}


// The tiers nearest completion: a pilot's own across every airframe, or the community's with one per pilot.
export async function fetchNextUnlocks({ pilotUid, limit }: { pilotUid?: string; limit?: number } = {}): Promise<import("../types/proficiencies").NextUnlocksResponse> {
  const url = apiUrl("/proficiencies/next_unlocks");
  if (pilotUid) url.searchParams.set("pilot_uid", pilotUid);
  if (limit != null) url.searchParams.set("limit", String(limit));
  const response = await fetch(url.toString());
  if (!response.ok) throw new Error(`Next unlocks request failed: ${response.status}`);
  return response.json();
}

export async function fetchProficienciesCatalogue(): Promise<import("../types/proficiencies").ProficienciesCatalogueResponse> {
  const response = await fetch(apiUrl("/proficiencies/catalogue"));
  if (!response.ok) throw new Error(`Catalogue request failed: ${response.status}`);
  return response.json();
}
